export const Standard = (value="") => {
    return {
        value:value,
        valide:null,
        touched:false
    };
}

export const Ringtyp = () => {
    return {
        value:"istRingGeschlossen",
        valide:null,
        touched:false
    };
}